import React, { useEffect, useState } from 'react';
import {
    Notification,
    CloseIconContainer,
    IconContainer,
    ContentContainer,
} from "./styles";
import Row from "../Row";
import Col from "../Col";
import CheckIcon from '../Icons/CheckIcon';
import Exclamation from '../Icons/Exclamation';
import WarningIcon from '../Icons/WarningIcon';
import InfoIcon from "../Icons/InfoIcon";
import CrossIcon from "../Icons/CrossIcon";

const ToastItem = (props) => {
    const {
        toast,
    } = props;

    const {
        type,
        msg,
    } = toast

    const Icon = () => {
        switch (type) {
            case "success":
                return <CheckIcon />;
            case "error":
                return <Exclamation />;
            case "warning":
                return <WarningIcon />;
            case "info":
                return <InfoIcon />;
            default:
                break;
        }
    };

    const Title = () => {
        switch (type) {
            case "success":
                return "موفق";
            case "error":
                return "خطا";
            case "warning":
                return "هشدار";
            case "info":
                return "";
            default:
                break;
        }
    };

    const ToastDuration = 5000; //مدت زمان نمایش پیام
    const [animation, setAnimation] = useState("show-toast") //انیمیشن toast
    const animationDuration = 1000;
    const [height, setHeight] = useState("auto")

    const onClose = () => {
        setAnimation("hide-toast")
        setTimeout(() => {
            setHeight("0")
        }, animationDuration)
    }

    useEffect(() => {
        setTimeout(() => {
            onClose()
        }, ToastDuration)
    }, [])

    return (
        <Notification
            type={type}
            animation={animation}
            animationDuration={animationDuration}
            height={height}
        >
            <Row className='progress' />
            <Row className='background'>
                <IconContainer 
                    type={type}
                    className={type}
                >
                    <Col>
                        {Icon()}
                    </Col>
                </IconContainer>
                <ContentContainer type={type}>
                    <Row className="notification-title">{Title()}</Row>
                    <Row className="notification-message">{msg}</Row>
                </ContentContainer>
                <CloseIconContainer onClick={onClose}>
                    <CrossIcon />
                </CloseIconContainer>
            </Row>
        </Notification>
    )
};

export default ToastItem;